import React from "react";
import { IconWrapper } from "./IconWrapper";
import { useRomaine } from "romaine";

/**
 * @copyright Ant Design Icons https://github.com/ant-design/ant-design-icons
 * @license MIT
 */
export const RotateRight = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
) => {
  const { setMode } = useRomaine();
  return (
    <IconWrapper
      selected="rotate-right"
      {...props}
      onClick={() => setMode && setMode("rotate-right")}
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 1024 1024"
        version="1.1"
        height="25px"
        width="25px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs></defs>
        <path d="M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-0.4-12.6 6.1l-0.2 64c-118.6 0.5-235.8 53.4-314.6 154.2-69.6 89.2-95.7 198.6-81.1 302.4h74.9c-0.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"></path>
        <path d="M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H396V494h440v326z"></path>
      </svg>
    </IconWrapper>
  );
};
